module.exports = {"640121001":"团结西路街道","640121100":"杨和镇","640121101":"李俊镇","640121102":"望远镇","640121103":"望洪镇","640121104":"闽宁镇","640121200":"胜利乡","640121400":"黄羊滩农场","640121401":"玉泉营农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/640121.json
// module id = 3170
// module chunks = 0